import { useContext } from 'react';

import { OverlayContext, type OverlayContextType } from '../contexts';

export const useOverlayContext = (): OverlayContextType => {
    const context = useContext(OverlayContext);
    if (!context) {
        throw new Error('useOverlayContext must be used within an OverlayProvider');
    }

    return context;
};
